import React from 'react';
// @ts-ignore
import cx from 'classnames';

import NumberFormat from 'react-number-format';

const cellStyle = {
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.15',
  letterSpacing: 'normal',
  color: '#1e1e1e',
};

const koefRenderrer = (fieldName: string) => (rowData: any) => (
  <NumberFormat
    value={rowData[fieldName]}
    displayType="text"
    suffix="x"
    decimalScale={2}
  />
);

const percentRenderrer = (fieldName: string) => (rowData: any) => (
  <NumberFormat value={rowData[fieldName]} displayType="text" suffix="%" />
);

const moneyRenderrer = (fieldName: string, currencySign: string) => (
  rowData: any,
) => (
  <NumberFormat
    value={rowData[fieldName]}
    displayType="text"
    prefix={currencySign}
    thousandSeparator={true}
    decimalScale={0}
  />
);

export function columns(currencySign = '$') {
  return [
    {
      title: 'Status',
      align: 'left',
      field: 'statusText',
      cellStyle: cellStyle,
      render: (rowData: any) => {
        const { statusText } = rowData;
        return (
          <span
            className={cx('cell-status text-capitalize', {
              active: statusText === 'active',
            })}
          >
            {statusText}
          </span>
        );
      },
    },
    {
      title: 'Company',
      align: 'left',
      field: 'company',
      render: (rowData: any) => (
        <a href={`/company/${rowData.company.id}/?aggrId=${rowData.fundId}`}>{rowData.company.name}</a>
      ),
      cellStyle: cellStyle,
    },
    {
      title: 'Cap Table',
      align: 'center',
      field: 'captable',
      render: (rowData: any) => (
        <a href={`${rowData.captableUrl}`}>
          <img
            className="svg-dark-invert"
            src="/static/icons/icon_external_link.svg"
            alt="Captable"
          />
        </a>
      ),
      cellStyle: cellStyle,
      sorting: false,
    },
    {
      title: 'Invested Capital',
      align: 'center',
      field: 'investedCapital',
      cellStyle: cellStyle,
      render: moneyRenderrer('investedCapital', currencySign),
    },
    {
      title: 'FD%',
      field: 'ownershipPercent',
      align: 'center',
      cellStyle: cellStyle,
      render: percentRenderrer('ownershipPercent'),
    },
    {
      title: 'NAV',
      field: 'nav',
      cellStyle: cellStyle,
      render: moneyRenderrer('nav', currencySign),
    },
    {
      title: 'EV',
      field: 'ev',
      cellStyle: cellStyle,
      render: moneyRenderrer('ev', currencySign),
    },
    {
      title: 'Multiple',
      field: 'multiple',
      cellStyle: cellStyle,
      render: koefRenderrer('multiple'),
    },
    {
      title: 'IRR',
      field: 'irr',
      cellStyle: cellStyle,
      render: percentRenderrer('irr'),
    },
  ];
}
